import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card-container flex align-items-left justify-content-start"
}
const _hoisted_2 = {
  key: 0,
  class: "mr-1"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "m-1" }, " |", -1)

import {RemoteWriterTimestamp} from "@/components/blocks/Types";
import {onMounted, ref, watch} from "vue";
import ClickIcon from "@/components/blocks/ClickIcon.vue";
import {useConfirm} from "primevue/useconfirm";

interface PropsInterface {
  writers: string[] | null,
  settings: RemoteWriterTimestamp[] | null
}

type WriterDef = {
  name: string,
  success: boolean,
  last: boolean
}

// Define props

export default /*#__PURE__*/_defineComponent({
  __name: 'WritersMarker',
  props: {
    writers: null,
    settings: null
  },
  emits: ['click'],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  writers: string[] | null,
  settings: RemoteWriterTimestamp[] | null
};




// Define refs
const writerDef = ref<WriterDef[]>([])
const allSuccess = ref<boolean>(false)

// Define use
const confirm = useConfirm()


// Define emits


// Define lifecycle hooks
onMounted(() => {
  initialize()
})

// Define watch
watch(() => props.settings, (current, prev) => {
  initialize()
})

// Define function
function initialize() {
  if (props.writers != null && props.writers.length > 0) {
    const result = [] as WriterDef[]
    for (let i = 0; i < props.writers.length; i++) {
      const writer = props.writers[i]
      result.push({
        name: props.writers[i],
        last: i == props.writers.length - 1,
        success: props.settings?.filter(item => item.name == writer)[0]?.success || false
      } as WriterDef)
    }

    allSuccess.value = !(result.some(it => it.success === false))
    writerDef.value = result
  }
}

function remoteWriteRequest() {

  confirm.require({
    message: 'Do you want write timeline to remote system?',
    header: 'Remote write request',
    icon: 'pi pi-question-circle',
    accept: () => {
      emits('click')
    }
  })


}


return (_ctx: any,_cache: any) => {
  return (__props.writers != null && __props.writers.length>0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(writerDef.value, (w, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass({'text-red-500': !w.success, 'text-green-500': w.success}),
            key: index
          }, [
            _createTextVNode(_toDisplayString(w.name) + " ", 1),
            (index<writerDef.value.length-1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, " |"))
              : _createCommentVNode("", true)
          ], 2))
        }), 128)),
        (!allSuccess.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(ClickIcon, {
                icon: "pi pi-upload",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (remoteWriteRequest()))
              })
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})